module.exports = __webpack_public_path__ + "static/media/a1.f4c21852.gif";